<template>

<div ref="ui-button-options-container" class="ui-button-options-container" v-touch:swipe.left.stop="swipeLeft" v-touch:swipe.right.stop="swipeRight" >
   <ui-button class="button" :style='getDynamicPosition()' :backgroundColor="backgroundColor" color="#000000">

      <div slot="left" v-if="$slots.left"><slot name="left"></slot></div>
      
      <div class="title" slot="title">
        <div class="title-left">
          {{tranlatedTitle}}
        </div>
        <div class="title-right">
          {{date}}
        </div>
      </div>
        
       
          <div class="subtitle" slot="subtitlebtn">
            <div>{{subtitle}}</div>
            <slot name="subtitle"/>
          </div>
       
        
        
        
        <!--
        <div class="subtitle" slot="subtitle" v-if="$slots.subtitle">
          <div>{{subtitle}}</div>
          <slot name="subtitle"></slot>
        </div>
        -->
        
        
      
      
      <slot name="right">
          <div slot="right">
            <!--<icon-button-chevron v-if="!$slots.options"/>-->
            <icon-button-options v-if="$slots.options" v-on:click.native.stop.prevent="clickIcon"/>
          </div>
      </slot>
  </ui-button>
  <div ref="options-buttons" class="options">
    <slot name="options"></slot>
  </div>

</div>
  
</template>

<script>
import UiButton from './UiButton.vue';
//import IconButtonChevron from './buttons/IconButtonChevron.vue';
import IconButtonOptions from './buttons/IconButtonOptions.vue';


export default {
  name: 'ui-button-options',
  props:{
    title:{default:"no title prop set."},
    subtitle:{default:undefined},
    date:{default:undefined},
    imageUrl:{default:""},
    backgroundColor:{default:"#FFFFFF"}
  },
  data:function(){
    return {
      open:false,
      optionsWidth:"0px",
      xStart:0,
      element:undefined,
    }
  },
  methods:{
    clickIcon(){
      //check if slot is empty and just execute normal behaviour (click on whole button)  
      var me;
      if(!this.open){
       me=this;
      }
      this.$root.$emit('CLOSE_ALL_OPTION_BUTTONS');
      
      if(me){
        me.open=true;
      }
      
    },
    swipeLeft(){
     //alert("gbaap")
     this.$root.$emit('CLOSE_ALL_OPTION_BUTTONS');
     this.open=true;
    },
    swipeRight(){
      this.open=false;
    },
    closeAllOptionbuttons(){
      if(this.open){
        this.open=false;
      }
    },
    getDynamicPosition(){
      if(this.open){
        return {transform:"translateX(-"+this.optionsWidth+"px)"}
      }else{
        return {transform:"translateX(0)"}
      }
      
    },
    touchStart(e){
     if(!e.targetTouches){return;}
      this.xStart=e.targetTouches[0].clientX;
    
    },
    touchEnd(e){
      if(!e.targetTouches){return;}
      this.started=false; 
    },
    touchMoving(e){
      if(!e.targetTouches){return;}

      var xEnd=e.targetTouches[0].clientX;
      var xDelta=xEnd-this.xStart;

      if(Math.abs(xDelta)>20){
        //e.preventDefault();
        //e.stopPropagation();
        //e.stopImmediatePropagation();
        
      }
      
    },
    addListeners(){
      this.element.addEventListener('touchstart',this.touchStart,{passive:true})
      this.element.addEventListener('touchEnd',this.touchEnd,{passive:true})
      this.element.addEventListener('touchmove',this.touchMoving,{passive:true})
    },
    removeListeners(){
      this.element.removeEventListener('touchstart',this.touchStart)
      this.element.removeEventListener('touchEnd',this.touchEnd)
      this.element.removeEventListener('touchmove',this.touchMoving)
    }
  },
  updated:function(){
    this.optionsWidth=this.$refs['options-buttons'].clientWidth;
    
  },
  beforeDestroy(){
    this.removeListeners();
  },
  mounted:function(){
    this.element=this.$refs['ui-button-options-container'];
    this.addListeners();
    //this.optionChildren=this.$slots.options ? true : false
    

    this.$root.$on('CLOSE_ALL_OPTION_BUTTONS',()=>{
      this.closeAllOptionbuttons();
    });
  },
  computed:{
    tranlatedTitle:function(){
      if(this.title.indexOf('language.')!==-1){
        return this.$t(this.title)
      }else{
        return this.title
      }
    }
  },
  components:{
    UiButton,
    //IconButtonChevron,
    IconButtonOptions,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ui-button-options-container{
  position:relative;
  background-color:#333333;
  justify-content: center;
  border-bottom:1px solid #DDDDDD;
}
.button{
  z-index:100;
  position:relative;
  /* override default button style */
  margin-bottom: 0; 
  border-radius:0;
  border:none;
  /* add new styling */
  color:#707070;
  transition:transform .25s;
}


.options{
  position:absolute;
  top:0;
  right:0;
  display:inline-block;
  height:100%;
  justify-content: center;
  align-items: center;
}
.options>div{
  height:100%; /* to accomodate slot styling for options */
}

.date{
  color:#FF0000;
}
.title{
  display:flex;
  padding:4px 0px;
}
.title-left{
  flex:1;
  word-break: break-all;
  
}
.title-right{
  font-size:.7em;
  color:#B7B7B7;
}
.subtitle{
  word-break:break-word;
}
</style>
